<section (mouseleave)="closepop()" class="cart-icons" id="miniCart">
  <a
    [ngbPopover]="popTitleSaveSuccess"
    #s1="ngbPopover"
    triggers="manual"
    placement="bottom"
    popoverClass="savedcartsuccess-msg"
    (click)="s1.close()"
  >
    <img
      class="cart-icon save-cart-icon"
      src="icons/saved-cart-icon-original.svg"
      alt="Saved Cart"
      (click)="navigateTominiSavedOrder()"
    />
  </a>
  <a
    class="clear-cart"
    *ngIf="isEmpty && !isFlu"
    [ngbPopover]="popContentEmpty"
    [popoverTitle]="popTitleEmpty"
    (mouseenter)="p1.open()"
    #p1="ngbPopover"
    placement="bottom"
    (click)="toggleWithGreeting(p1)"
    popoverClass="minicart-std-popover"
  >
    <img class="cart-icon" src="icons/cart-icon.svg" alt="View Mini Cart" />
  </a>
  <a
    class="clear-cart"
    *ngIf="!isEmpty && !isFlu"
    [ngbPopover]="popContentStd"
    [popoverTitle]="popTitleStd"
    popoverClass="minicart-std-popover"
    (mouseenter)="p2.open()"
    #p2="ngbPopover"
    placement="bottom"
    (click)="toggleWithGreeting(p2)"
  >
    <img
      class="cart-icon"
      src="icons/cart-icon.svg"
      alt="View Mini Cart"
      [ngbPopover]="popTitleSessionCart"
      #c1="ngbPopover"
      triggers="manual"
      placement="bottom"
      popoverClass="itemincart-success-msg"
      (click)="c1.close()"
      container="body"
    />
    <p class="cartvalue">{{ quantityDisplay }}</p>
  </a>
  <a
    class="clear-cart"
    *ngIf="!isEmptyFlu && isFlu"
    [ngbPopover]="popContentFlu"
    [popoverTitle]="popTitleFlu"
    (mouseenter)="p4.open()"
    #p4="ngbPopover"
    placement="bottom"
    (click)="toggleWithGreeting(p4)"
  >
    <img class="cart-icon" src="icons/cart-icon.svg" alt="View Mini Cart" />
    <p class="cartvalue">{{ quantityDisplayFlu }}</p>
  </a>
  <a
    class="clear-cart"
    *ngIf="isEmptyFlu && isFlu"
    [ngbPopover]="popContentEmpty"
    [popoverTitle]="popTitleEmpty"
    (mouseenter)="p1.open()"
    #p1="ngbPopover"
    placement="bottom"
    (click)="toggleWithGreeting(p1)"
  >
    <img class="cart-icon" src="icons/cart-icon.svg" alt="View Mini Cart" />
  </a>
</section>
<section class="cart-popover">
  <ng-template #popTitleEmpty>
    <div class="minicart-header font-bold">
      <span class="mini-triangle"></span>
      <p class="text-center mb-0">
        {{ 'addToCartItems.emptycart' | cxTranslate }}
      </p>
    </div>
  </ng-template>
  <ng-template #popContentEmpty>
    <div class="miniCart-listitem">
      <div class="text-center mt-4">
        <a
          class="c-link a-no-styles"
          title="Order Products"
          (click)="navigateToPdp()"
          >{{ 'addToCartItems.emptyOrderProduct' | cxTranslate }}</a
        ><br /><br />
        <a
          class="c-link a-no-styles"
          title="Save Order"
          (click)="navigateToSavedOrder()"
          >{{ 'addToCartItems.emptySaveOrders' | cxTranslate }}</a
        >
      </div>
    </div>
  </ng-template>
</section>

<section class="cart-popover text-left">
  <ng-template #popTitleStd>
    <div class="minicart-header font-bold">
      <span class="mini-triangle"></span>
      <span class="mini-cart-title"></span>
      {{ 'addToCartItems.orderSubtotal' | cxTranslate }}
      {{ stdCartEntries?.subTotal?.value | currency }}
      {{ stdCartEntries?.subTotal?.currencyIso }}
    </div>
  </ng-template>
  <ng-template #popContentStd>
    <section class="cart-prod-list">
      <section class="unit-numbers">
        <span class="">
          {{ totalQuantity }} {{ 'addToCartItems.units' | cxTranslate }}
        </span>
      </section>
      <section class="cart-details-minicart">
        <ul
          class="cart-prod-details"
          *ngFor="let productentry of productEntries.slice().reverse()"
        >
          <li>
            <a
              class="miniCart-prod-details text-decoration-none"
              (click)="navigatetoProduct(productentry?.product?.code)"
            >
              <div class="img-info">
                <div class="img-holder">
                  <img
                    *ngIf="productentry?.product?.images != null"
                    class="flu-poster img_loaded"
                    src="{{ productentry?.PRIMARY?.url }}"
                    alt=""
                  />
                  <img
                    *ngIf="productentry?.product?.images == null"
                    [src]="fallbackImage"
                    alt=""
                    class="flu-poster img_loaded"
                  />
                </div>
                <div class="info">
                  <span
                    class="cart-prod-title"
                    [innerHTML]="productentry?.product?.name"
                  ></span>

                  <p class="miniCart-price">
                    {{ productentry?.basePrice?.value | currency }}
                  </p>
                </div>
              </div>
              <div class="count mr-4 pl-2">
                <span class="minicart-prod-doses">{{
                  productentry?.quantity
                }}</span>
              </div>
            </a>
          </li>
        </ul>
      </section>
      <section class="cart-footer savepopover">
        <button
          type="button"
          (click)="navigateToCart()"
          class="c-button c-button--primary"
        >
          {{ 'addToCartItems.viewcart' | cxTranslate }}
        </button>

        <button
          type="button"
          class="c-button c-button--secondary"
          [ngbPopover]="popSaveContent"
          [popoverTitle]="popSaveTitle"
          triggers="manual"
          #s3="ngbPopover"
          placement="left"
          popoverClass="savedordermini-popover"
          (click)="toggle(s3)"
        >
          {{ 'addToCartItems.savecart' | cxTranslate }}
        </button>
        <ng-template #popSaveTitle
          ><p class="px-4 m-0 mb-2 minicart-savepopover">
            {{ 'addToCartItems.saveOrderTitle' | cxTranslate }}
          </p>
        </ng-template>
        <ng-template #popSaveContent>
          <input
            type="text"
            class="save-order save-order-mini mb-0 mb-4"
            #name="ngModel"
            required
            [(ngModel)]="saveCartName"
            (keypress)="omit_special_char($event)"
            maxlength="30"
          />

          <span *ngIf="name.errors?.required" class="common-error required">{{
            errorMsg
          }}</span>
          <span class="common-error required">{{ errorMsg }}</span>

          <div class="d-flex justify-content-between mt-2 mb-2">
            <button
              type="button"
              class="c-button c-button--secondary"
              (click)="toggle(s3)"
            >
              {{ 'addToCartItems.cancel' | cxTranslate }}
            </button>
            <button
              class="c-button c-button--primary"
              type="submit"
              data-di-id="di-id-3064f17d-e97cc628"
              (click)="saveOrder()"
            >
              {{ 'addToCartItems.save' | cxTranslate }}
            </button>
          </div>
        </ng-template>
      </section>
    </section>
  </ng-template>
</section>

<section class="cart-popover">
  <ng-template #popTitleFlu>
    <div class="minicart-header">
      <span class="mini-triangle"></span>
      <span class="mini-cart-title"></span>
      {{ 'addToCartItems.orderSubtotal' | cxTranslate }}
      {{ fluCartEntries?.subTotal?.value | currency }}
      {{ fluCartEntries?.subTotal?.currencyIso }}
    </div>
  </ng-template>
  <ng-template #popContentFlu>
    <section class="cart-prod-list">
      <section class="unit-numbers">
        <span class=""
          >{{ totalQuantityFlu }}
          {{ 'addToCartItems.units' | cxTranslate }}</span
        >
      </section>
      <section class="cart-details-minicart">
        <ul
          class="cart-prod-details"
          *ngFor="let productentry of productFluEntries"
        >
          <li>
            <a (click)="navigatetoProduct(productentry?.product?.code)">
              <span class="miniCart-prod-details">
                <img
                  *ngIf="productentry?.product?.images != null"
                  class="flu-poster img_loaded"
                  src="{{ productentry.PRIMARY.url }}"
                  alt=""
                />
                <img
                  *ngIf="productentry?.product?.images == null"
                  [src]="fallbackImage"
                  alt=""
                  class="flu-poster img_loaded"
                />
              </span>
              <span
                class="cart-prod-title"
                [innerHTML]="productentry?.product?.name"
              ></span
            ></a>
            <span class="minicart-prod-doses">{{
              productentry?.quantity
            }}</span>
            <p class="miniCart-price flu-minicart-price">
              {{ productentry?.basePrice?.value | currency }}
            </p>
          </li>
        </ul>
      </section>
      <section class="cart-footer savepopover">
        <a role="presentation" data-di-id="di-id-c676ac20-ae73fdd6">
          <button
            type="button"
            (click)="navigateToFlufromCart()"
            class="btn btn-default blue-button"
          >
            {{ 'addToCartItems.viewcart' | cxTranslate }}
          </button>
        </a>
      </section>
    </section>
  </ng-template>
</section>

<section class="added-success-container">
  <ng-template #popTitleSuccess>
    <div class="cart-value-added">
      <img
        src="icons/confirmation-positive-green.png"
        class="positive-green-icon"
        alt="success"
      />
      <span class="confirmation-itemsadded"
        >{{ itemAddedQuantity }}
        {{ 'addToCartItems.addEntrySuccess' | cxTranslate }}</span
      >
    </div>
  </ng-template>
</section>
<ng-template #popTitleSaveSuccess>
  <div class="cart-value-added">
    <img
      src="icons/confirmation-positive-green.png"
      class="positive-green-icon"
      alt="success"
    />
    <span class="confirmation-itemsadded"
      >{{ cartSavedSuccess }}
      {{ 'addToCartItems.savesuccess' | cxTranslate }}</span
    >
  </div>
</ng-template>

<ng-template #popMinicartItems>
  <div class="cart-value-added">
    <img
      src="icons/confirmation-positive-green.png"
      class="positive-green-icon"
      alt="success"
    />
    <span class="confirmation-itemsadded"
      >{{ quantityDisplay }}
      {{ 'addToCartItems.sessionCartMsg' | cxTranslate }}</span
    >
  </div>
</ng-template>
<ng-template #popTitleSessionCart>
  <div class="cart-value-added">
    <img src="icons/info.png" class="positive-green-icon" alt="info" />
    <span class="confirmation-itemsadded"
      >{{ quantityDisplay }}
      {{ 'addToCartItems.sessionCartMsg' | cxTranslate }}</span
    >
  </div>
</ng-template>
